import { useEffect } from 'react'

import { usePortfolioPermissions } from '../hooks'
import PortfoliosLayout from '../layout/portfolios-layout/portfolios-layout'
import { actions as rawActions } from '../state/edit-portfolio-slice'
import { useAppSelector } from '../store/hooks'
import { useActions } from '../store/use-actions'

export const PortfolioAdminWithState = () => {
  const state = useAppSelector(state => state.editPortfolios)
  const actions = useActions(rawActions)
  useEffect(() => {
    actions.init()
  }, [actions])

  const {
    areDisallowedStrategiesOverridden,
    canUserSave,
    canUserStartNew,
    isAllowedToViewSelectedPortfolio
  } = usePortfolioPermissions(state)

  useEffect(() => {
    if (!isAllowedToViewSelectedPortfolio) {
      actions.stopInspecting()
    }
  }, [isAllowedToViewSelectedPortfolio, actions])

  return (
    <PortfoliosLayout
      actions={actions}
      areDisallowedStrategiesOverridden={areDisallowedStrategiesOverridden}
      canUserSave={canUserSave}
      canUserStartNew={canUserStartNew}
      state={state}
    />
  )
}
